import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-PepiconsCircleFilled",
  "use": "icon-PepiconsCircleFilled-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-PepiconsCircleFilled\"><circle cx=\"10\" cy=\"10\" r=\"6\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol